var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequestsImgHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 18,
    viewBox: "0 0 27 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 3C18.5527 3 19 3.44772 19 4V7C19 7.55228 18.5527 8 18 8C17.4473 8 17 7.55228 17 7V4C17 3.44772 17.4473 3 18 3Z",
    fill: "#2A7F77"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 10C19 9.44772 18.5527 9 18 9C17.4473 9 17 9.44772 17 10C17 10.5523 17.4473 11 18 11C18.5527 11 19 10.5523 19 10Z",
    fill: "#2A7F77"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0C9.44727 0 9 0.447723 9 1V13C9 13.5523 9.44727 14 10 14H12.5V17C12.5 17.3938 12.7314 17.7509 13.0908 17.9122C13.4492 18.0735 13.8701 18.009 14.1641 17.7474L18.3799 14H26C26.5527 14 27 13.5523 27 13V1C27 0.447723 26.5527 0 26 0H10ZM11 2H25V12H18C17.7549 12 17.5186 12.0899 17.3359 12.2526L14.5 14.7732V13C14.5 12.4477 14.0527 12 13.5 12H11V2Z",
    fill: "#2A7F77"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M1 2C0.447266 2 0 2.44772 0 3C0 3.55228 0.447266 4 1 4H7C7.55273 4 8 3.55228 8 3C8 2.44772 7.55273 2 7 2H1Z",
    fill: "#2A7F77"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M2 7C2 6.44772 2.44727 6 3 6H7C7.55273 6 8 6.44772 8 7C8 7.55228 7.55273 8 7 8H3C2.44727 8 2 7.55228 2 7Z",
    fill: "#2A7F77"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M5 10C4.44727 10 4 10.4477 4 11C4 11.5523 4.44727 12 5 12H7C7.55273 12 8 11.5523 8 11C8 10.4477 7.55273 10 7 10H5Z",
    fill: "#2A7F77"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestsImgHover);
export default __webpack_public_path__ + "static/media/requestsImgHover.14c38821289ad313c0a2ef70600d7c8e.svg";
export { ForwardRef as ReactComponent };